import { TipoNotificacaoEnum } from '../enums/tipo-notificacao.enum';

/** Metadados fixos de cada tipo — única fonte de verdade para tela e regras. */
export interface PreferenciaNotificacaoDefinicao {
  tipo: TipoNotificacaoEnum;
  titulo: string;
  descricao: string;
  /** Agrupamento na interface (pt-BR). */
  categoria: string;
  ordem: number;
  obrigatorio?: boolean;
  /** Valor inicial quando o usuário ainda não salvou preferências. */
  defaultHabilitado?: boolean;
}

/**
 * Tipos de notificação que o usuário pode ativar ou desativar.
 * Novos tipos: incluir em {@link TipoNotificacaoEnum} e neste catálogo.
 */
export const PREFERENCIA_NOTIFICACAO_CATALOG: PreferenciaNotificacaoDefinicao[] = [
  {
    tipo: TipoNotificacaoEnum.ANDAMENTO_SOLICITACAO,
    titulo: 'Andamento de solicitações',
    descricao:
      'Avisos quando uma solicitação em que você participa recebe movimentação, comentário ou mudança de situação.',
    categoria: 'Solicitações',
    ordem: 1,
    defaultHabilitado: true,
  },
  {
    tipo: TipoNotificacaoEnum.NOVA_SOLICITACAO,
    titulo: 'Novas solicitações na sua unidade',
    descricao: 'Quando uma nova solicitação é aberta ou direcionada para unidades em que você atua.',
    categoria: 'Solicitações',
    ordem: 2,
    defaultHabilitado: true,
  },
  {
    tipo: TipoNotificacaoEnum.ADMINISTRATIVA,
    titulo: 'Administrativas',
    descricao: 'Comunicados institucionais, prazos e avisos de gestão relevantes ao seu perfil.',
    categoria: 'Geral',
    ordem: 3,
    defaultHabilitado: true,
  },
  {
    tipo: TipoNotificacaoEnum.ALERTA_SISTEMA,
    titulo: 'Alertas do sistema',
    descricao: 'Manutenção programada, indisponibilidade temporária e mensagens críticas de segurança.',
    categoria: 'Sistema',
    ordem: 4,
    obrigatorio: true,
    defaultHabilitado: true,
  },
];

/** Ordem estável das categorias conforme primeira aparição no catálogo (por `ordem`). */
export const ORDEM_CATEGORIAS_PREFERENCIA_NOTIFICACAO: string[] = [
  ...new Set([...PREFERENCIA_NOTIFICACAO_CATALOG].sort((a, b) => a.ordem - b.ordem).map(d => d.categoria)),
];
